import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
  Upload,
} from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { find, isEmpty, sortBy } from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BrandApi from '../../functions/api/vehicle/BrandApi';
import DesignApi from '../../functions/api/vehicle/DesignApi';
import FuelApi from '../../functions/api/vehicle/FuelApi';
import ImageApi from '../../functions/api/vehicle/ImageApi';
import ModelApi from '../../functions/api/vehicle/ModelApi';
import OptionApi from '../../functions/api/vehicle/OptionApi';
import SeatApi from '../../functions/api/vehicle/SeatApi';
import TransmissionApi from '../../functions/api/vehicle/TransmissionApi';
import TypeApi, { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import VehicleApi from '../../functions/api/vehicle/VehicleApi';
import { filterOption, normalizeOptions } from '../booking/form/CustomSelect';
import SelectBrands from '../vehiclePartner/select/Brand';

const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }

  return e && e.fileList;
};

class FormAddCar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types: [],
      brands: [],
      models: [],
      transmissions: [],
      seats: [],
      fuels: [],
      options: [],
      designs: [],
      isEdit: false,
      vehicles: null,
      brandId: null,
      vhc_options: [],
    };
  }
  formRef = React.createRef();

  componentDidMount = async () => {
    let brands, seats, fuels, transmissions, options, designs, models, types;
    brands = await BrandApi.getBrandByType(VEHICLE_TYPES.CAR);
    brands = brands ? brands : [];

    types = await TypeApi.getAll();
    types = types ? types : [];

    seats = await SeatApi.getAllSeat();
    seats = seats ? seats : [];

    models = await ModelApi.getModelByType(VEHICLE_TYPES.CAR);
    models = models ? models : [];

    designs = await DesignApi.getAllDesign();
    designs = designs ? designs : [];

    transmissions = await TransmissionApi.getAllTransmisssion(
      VEHICLE_TYPES.CAR
    );
    transmissions = transmissions ? transmissions : [];

    fuels = await FuelApi.getAllFuel();
    fuels = fuels ? fuels : [];

    options = await OptionApi.getAllOption();
    options = options ? options : [];

    this.setState({
      brands,
      seats,
      models,
      designs,
      transmissions,
      options,
      fuels,
      types,
    });

    if (
      this.props.match.params &&
      this.props.match.path === '/vehicle-depot/edit-car-depot/:vhc_id'
    ) {
      let vhc_id = this.props.match.params.vhc_id;
      if (vhc_id) {
        let detail = await VehicleApi.getDetailVehicle(vhc_id);

        detail.version = detail.vhc_name;
        detail.option = !isEmpty(detail.vhc_opts)
          ? detail.vhc_opts.map((d) => d.vhc_opt_name)
          : [];

        if (detail.vhc_type_id === VEHICLE_TYPES.CAR) {
          this.setState({ isEdit: true });
        }

        this.setState({
          vehicle: detail,
        });

        this.formRef.current.setFieldsValue({
          vhc_options: detail?.option || [],
        });
      }
    }
  };

  onChangeSelectBrand = async (event) => {
    const { brandId } = this.state;

    if (event !== brandId) {
      this.formRef.current.setFieldsValue({
        vhc_modl_id: null,
      });
    }
    if (event) {
      const models = await ModelApi.getModelByBrand(event);

      this.setState({ models });
    }
    this.setState({
      brandId: event,
    });
  };

  handleImage = async (e) => {
    const path = await ImageApi.uploadHandler(e);

    return path;
  };

  submitForm = async (values) => {
    const {
      brands,
      models,
      seats,
      transmissions,
      fuels,
      designs,
      isEdit,
      vehicle,
      types,
    } = this.state;
    let payload = {
      ...values,
    };
    let img;
    if (!isEdit) {
      img = await this.handleImage(payload.img[0]);
    } else {
      if (isEmpty(payload.img)) {
        img = vehicle?.vhc_imgs[0]?.vhc_img_link;
      } else {
        img = await this.handleImage(payload.img[0]);
      }
    }

    payload.vhc_imgs = img;
    delete payload.img;

    const vhc_bran_name = find(brands, {
      vhc_bran_id: payload.vhc_bran_id,
    })?.vhc_bran_name;
    payload.vhc_bran_name = vhc_bran_name;

    const vhc_modl_name = find(models, {
      vhc_modl_id: payload.vhc_modl_id,
    })?.vhc_modl_name;
    payload.vhc_modl_name = vhc_modl_name;

    const vhc_seat_num = find(seats, {
      vhc_seat_id: payload.vhc_seat_id,
    })?.vhc_seat_num;
    payload.vhc_seat_num = vhc_seat_num;

    const vhc_tms_name = find(transmissions, {
      vhc_tms_id: payload.vhc_tms_id,
    })?.vhc_tms_name;
    payload.vhc_tms_name = vhc_tms_name;

    const vhc_fuel_name = find(fuels, {
      vhc_fuel_id: payload.vhc_fuel_id,
    })?.vhc_fuel_name;
    payload.vhc_fuel_name = vhc_fuel_name;

    const vhc_dgn_name = find(designs, {
      vhc_dgn_id: payload.vhc_dgn_id,
    })?.vhc_dgn_name;
    payload.vhc_dgn_name = vhc_dgn_name;

    payload.vhc_type_id = VEHICLE_TYPES.CAR;

    const vhc_type_name = find(types, {
      vhc_type_id: VEHICLE_TYPES.CAR,
    })?.vhc_type_name;
    payload.vhc_type_name = vhc_type_name;

    payload.vhc_opts =
      payload.vhc_options.length > 1 ? payload.vhc_options[0] : '';
    for (let i = 1; i < payload.vhc_options.length; i++)
      payload.vhc_opts += ',' + payload.vhc_options[i];

    payload.vhc_crta = new Date();

    payload.vhc_id = isEdit ? vehicle.vhc_id : undefined;

    payload.vhc_name = payload.version;

    await this.handleCreate(payload);
  };

  handleCreate = async (payload) => {
    const { isEdit } = this.state;

    let res;
    if (isEdit) {
      await VehicleApi.editCar(payload).then((response) => (res = response));
    } else
      await VehicleApi.creatCar(payload).then((response) => (res = response));
    if (res.code === 'error') {
      message.error('Lỗi, hãy kiểm tra lại');
    } else {
      if (isEdit) {
        message.success('Cập nhập xe thành công');
      } else {
        message.success('Thêm xe xe thành công');
      }
    }
  };

  render() {
    const {
      seats,
      fuels,
      transmissions,
      options,
      designs,
      models,
      isEdit,
      vehicle,
    } = this.state;

    if (!vehicle && isEdit) {
      return <Spin />;
    }

    return (
      <>
        {!isEdit ? (
          <>
            <Button type="primary">
              <a className="tab-car active">Ô tô</a>
            </Button>
            <Button>
              <Link to="/vehicle-depot/add-motorbike" className="tab-moto">
                Xe máy
              </Link>
            </Button>
          </>
        ) : (
          <h1>Sửa xe ô tô</h1>
        )}

        <Form
          {...formItemLayout}
          initialValues={vehicle}
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['version']}
                label="Nhập Version"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_bran_id']}
                label="Hãng xe"
                rules={[{ required: true }]}
              >
                <SelectBrands
                  onBrandChange={this.onChangeSelectBrand}
                  vehicleType={VEHICLE_TYPES.CAR}
                  selected={vehicle?.vhc_bran_id}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_modl_id']}
                label="Dòng xe"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_modl_name',
                    'vhc_modl_id',
                    models
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_dgn_id']}
                label="Kiểu dáng"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_dgn_name',
                    'vhc_dgn_id',
                    designs
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_seat_id']}
                label="Chọn số chỗ"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={sortBy(seats, ['vhc_seat_num']).map((s) => ({
                    value: s.vhc_seat_id,
                    label: `${s.vhc_seat_num} chỗ `,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_tms_id']}
                label="Chọn loại hộp số"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_tms_name',
                    'vhc_tms_id',
                    transmissions
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_fuel_id']}
                label="Chọn loại nhiên liệu"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_fuel_name',
                    'vhc_fuel_id',
                    fuels
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_fuel_csum_num']}
                label="Nhập mức tiêu hao nhiên liệu"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_egin_num']}
                label="Nhập dung tích xi lanh"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                label="Chọn option của xe"
                rules={[{ required: true }]}
                name={['vhc_options']}
              >
                <Select
                  mode="multiple"
                  showArrow
                  defaultValue={vehicle?.option}
                  style={{ width: '100%' }}
                  filterOption={filterOption}
                  options={normalizeOptions(
                    'vhc_opt_name',
                    'vhc_opt_name',
                    options
                  )}
                />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={['vhc_hide']}
                valuePropName="checked"
                label="Ẩn xe"
              >
                <Checkbox>Ẩn</Checkbox>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['vhc_luxury']}
                valuePropName="checked"
                label="Xe sang"
              >
                <Checkbox>Xe sang</Checkbox>
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name="img"
                label="Upload"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload listType="picture">
                  <Button icon={<UploadOutlined />}>
                    {isEdit ? 'Thay ảnh xe' : 'Upload ảnh xe'}
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            {isEdit && (
              <Image width={200} src={vehicle?.vhc_imgs[0]?.vhc_img_link} />
            )}
          </Row>
          <Space>
            <Button htmlType="submit" type="primary">
              Lưu
            </Button>
            <Link
              to="/vehicle-depot"
              component={(props) => (
                <Button type="default" {...props}>
                  Quay lại
                </Button>
              )}
            />
          </Space>
        </Form>
      </>
    );
  }
}

export default FormAddCar;
